var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "diamond_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.61 3.116a.557.557 0 0 1 .788 0l6.461 6.462c.184.184.216.47.078.69l-6.462 10.268a.557.557 0 0 1-.942 0L5.07 10.268a.56.56 0 0 1 .077-.69z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#diamond_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 3h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 3h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 3h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 3h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 3h3v3h-3zM3 6h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 6h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 6h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 6h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 6h3v3h-3zM3 9h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 9h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 9h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 9h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 9h3v3h-3zM3 12h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 12h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 12h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 12h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 12h3v3h-3zM3 15h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 15h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 15h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 15h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 15h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 15h3v3h-3zM3 18h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 18h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 18h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 18h3v3h-3z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.602 3.023c.22-.22.576-.22.796 0l6.527 6.527a.56.56 0 0 1 .078.697L12.476 20.62a.562.562 0 0 1-.952 0L4.997 10.247a.56.56 0 0 1 .078-.697z",
    style: {
      stroke: "var(--accent-stroke)",
      strokeWidth: "var(--accent-stroke-width)"
    }
  }));
};
export default SvgDiamond;